module.exports = require('./data.json')



//////////////////
// WEBPACK FOOTER
// ./node_modules/china-area-data/data.js
// module id = Tdz7
// module chunks = 5